module.exports = __webpack_public_path__ + "static/media/item_2_5.9064dc69.png";